/* hbi-calc-layout.js - Option B layout for the calculator pages (2026-10-30).
 *
 * WHY: the calculators were restyled to the Learning Center look (assets/hbi-pages.css v2). This script
 * turns a calculator into the two-column layout on wide screens: inputs card on the left, a live result
 * panel on the right, with the quick-reference table and heatmap under the inputs so the columns stay
 * level. It only moves existing elements; the calculator's own JS keeps working because every id stays.
 *
 * It runs on pages with a wrapper id="hb-...-page" that contain ONE result block (.hb-results or
 * .hb-results-wrap) inside the first .hb-card. Pages without that (CEA ROI, Electricity, Yield until
 * their results get a wrapper; the three multi-tab tools) are left as a single column and still get
 * the new look from the CSS. Results update as the inputs change (the page's own Calculate button is
 * clicked for it), so the Calculate button row is hidden by CSS once the layout is applied.
 *
 * The "products that fit" strip (.hb-fit) is reserved here for the spec-data phase; nothing is injected
 * until a calculator declares data-fit-collection + data-fit-spec on its wrapper.
 */
(function () {
  var page = document.querySelector('.hb-tool[id^="hb-"][id$="-page"]');
  if (!page) return;
  var card = page.querySelector('.hb-card');
  if (!card) return;
  var results = card.querySelectorAll('.hb-results, .hb-results-wrap');
  // CEA ROI + Yield name their result box "<tool>-results" (aria-live) instead of .hb-results: use that (11-03)
  if (!results.length) results = card.querySelectorAll('[id$="-results"][aria-live]');
  if (results.length !== 1 || page.querySelector('.hb-panel-results')) { page.classList.add('hb-layout-single'); return; }
  var result = results[0];

  var two = document.createElement('div'); two.className = 'hb-two';
  card.parentNode.insertBefore(two, card);
  var left = document.createElement('div'); left.className = 'hb-leftcol'; two.appendChild(left); left.appendChild(card);
  var col = document.createElement('div'); col.className = 'hb-resultcol'; two.appendChild(col);
  result.removeAttribute('hidden'); result.style.display = ''; col.appendChild(result);

  // reference table + heatmap move under the inputs
  var ref = page.querySelector('.hb-ref-section');
  var refLabel = page.querySelector('.hb-ref-label'), refWrap = page.querySelector('.hb-ref-table-wrap');
  if (ref) { left.appendChild(ref); }
  else { if (refLabel) left.appendChild(refLabel); if (refWrap) left.appendChild(refWrap); }
  var chart = page.querySelector('.hb-chart-section'); if (chart) left.appendChild(chart);

  // live results: reuse the page's own Calculate / Reset / Copy buttons
  var actions = card.querySelector('.hb-actions');
  var calcBtn = actions ? actions.querySelector('.hb-btn--primary') : null;
  var resetBtn = actions ? actions.querySelector('[id$="reset-btn"], [id*="reset"]') : null;
  var copyBtn = actions ? actions.querySelector('[id$="copy-btn"], [id*="copy"]') : null;
  var heroVal = result.querySelector('.hb-result-value');
  function run() {
    if (calcBtn) calcBtn.click();
    result.removeAttribute('hidden'); result.style.display = '';
    var sb = page.querySelector('.hb-stickybar b');
    if (sb && heroVal) sb.textContent = heroVal.textContent.replace(/\s*[µu]mol.*$/, '').trim() || '—';
  }
  card.querySelectorAll('input, select').forEach(function (el) {
    el.addEventListener('input', run); el.addEventListener('change', run);
  });
  card.querySelectorAll('.hb-mode button').forEach(function (b) { b.addEventListener('click', function () { setTimeout(run, 0); }); });
  if (actions) {
    var note = document.createElement('p'); note.className = 'hb-live-note';
    note.appendChild(document.createTextNode('Results update as you type. '));
    if (resetBtn) { var r = document.createElement('button'); r.type = 'button'; r.className = 'hb-btn hb-btn--light hb-btn--sm'; r.textContent = 'Reset'; r.addEventListener('click', function () { resetBtn.click(); setTimeout(run, 50); }); note.appendChild(r); }
    if (copyBtn) { var c = document.createElement('button'); c.type = 'button'; c.className = 'hb-btn hb-btn--light hb-btn--sm'; c.textContent = 'Copy results'; c.addEventListener('click', function () { copyBtn.click(); }); note.appendChild(c); }
    actions.insertAdjacentElement('afterend', note);
  }

  // phone: sticky bar with the headline number
  var label = result.querySelector('.hb-result-label');
  var bar = document.createElement('div'); bar.className = 'hb-stickybar';
  bar.innerHTML = '<div><span></span><b>—</b></div><a href="#">See results</a>';
  bar.querySelector('span').textContent = label ? label.textContent.trim() : 'Your result';
  var id = result.id || (result.id = page.id + '-results'); bar.querySelector('a').setAttribute('href', '#' + id);
  page.appendChild(bar);
  page.classList.add('hb-layout-two');
  run();
  // some pages (Yield) wire up their Calculate button after this script runs: fill the results again once loaded
  if (document.readyState !== 'complete') window.addEventListener('load', function () { setTimeout(run, 0); });
})();
